(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["launch-holidays"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('la-holiday-shelf')) {
    customElements.define('la-holiday-shelf', class extends HTMLElement {
      connectedCallback() {
        this.shelf = this.querySelector('.la-holidays__shelf');
        this.controls = this.querySelector('.la-holidays__controls');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.controls.addEventListener('click', event => {
          const button = event.target.closest('button[data-direction]');
          if (!button) return;
          this.shelf.scrollBy({ left: Number(button.dataset.direction) * this.shelf.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, options);
        this.update = () => {
          const maximum = this.shelf.scrollWidth - this.shelf.clientWidth;
          this.controls.hidden = maximum <= 2;
          this.controls.querySelector('[data-direction="-1"]').disabled = this.shelf.scrollLeft <= 2;
          this.controls.querySelector('[data-direction="1"]').disabled = this.shelf.scrollLeft >= maximum - 2;
        };
        this.shelf.addEventListener('scroll', this.update, options);
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.shelf);
        this.update();
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stella-portrait-video"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('la-stella-film')){
  customElements.define('la-stella-film',class extends HTMLElement{
    connectedCallback(){
      if(this.bound)return;
      this.bound=true;this.abort=new AbortController();
      this.video=this.querySelector('video');this.playButton=this.querySelector('[data-play]');this.video.muted=true;this.video.defaultMuted=true;
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.manualPaused=false;this.visible=false;this.loaded=false;this.autoPausing=false;
      const opts={signal:this.abort.signal};
      this.load=()=>{if(this.loaded)return;this.loaded=true;this.video.querySelectorAll('source[data-src]').forEach(s=>{s.src=s.dataset.src;});this.video.load();};
      this.pauseAuto=()=>{if(!this.video.paused){this.autoPausing=true;this.video.pause();}};
      this.playVideo=()=>{this.load();this.video.play().catch(()=>{this.querySelector('.stella-film__status').textContent='Select Play video to start playback.';});};
      this.sync=()=>{const label=this.video.paused?'Play video':'Pause video';this.playButton.setAttribute('aria-label',label);this.playButton.querySelector('span').textContent=this.video.paused?'▶':'Ⅱ';};
      this.playButton.addEventListener('click',()=>{if(this.video.paused){this.manualPaused=false;this.playVideo();}else{this.manualPaused=true;this.video.pause();}},opts);
      this.video.addEventListener('pause',()=>{if(this.autoPausing)this.autoPausing=false;else this.manualPaused=true;this.sync();},opts);
      this.video.addEventListener('play',()=>{this.manualPaused=false;this.sync();},opts);
      this.video.addEventListener('volumechange',()=>{if(!this.video.muted)this.video.muted=true;},opts);
      this.video.addEventListener('error',()=>{this.querySelector('.stella-film__status').textContent='Video could not load. Please try Play video again.';},opts);
      this.nearObserver=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){if(!this.motion.matches)this.load();this.nearObserver.disconnect();}},{rootMargin:'400px'});this.nearObserver.observe(this);
      this.visibleObserver=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=0.25;if(!this.visible||document.hidden)this.pauseAuto();else if(!this.motion.matches&&!this.manualPaused)this.playVideo();},{threshold:[0,0.25]});this.visibleObserver.observe(this.video);
      document.addEventListener('visibilitychange',()=>{if(document.hidden)this.pauseAuto();else if(this.visible&&!this.motion.matches&&!this.manualPaused)this.playVideo();},opts);
      this.motion.addEventListener('change',()=>{if(this.motion.matches)this.pauseAuto();else if(this.visible&&!this.manualPaused)this.playVideo();},opts);
      this.sync();
    }
    disconnectedCallback(){this.abort?.abort();this.nearObserver?.disconnect();this.visibleObserver?.disconnect();this.video?.pause();this.bound=false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-offer"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-welcome-offer]').forEach((root) => {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const review = root.dataset.review === 'true';
  const dialog = root.querySelector('dialog');
  const opener = root.querySelector('.welcome-review__float');
  const key = 'la-welcome15-v1';
  const read = () => { try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch { return {}; } };
  const write = (value) => { try { localStorage.setItem(key, JSON.stringify(value)); } catch {} };
  let timer;
  let previousFocus;
  const suppressed = () => root.dataset.knownIneligible === 'true' || read().signedUp || read().dismissUntil > Date.now();
  const open = () => {
    clearTimeout(timer);
    if (!dialog.open) { previousFocus = document.activeElement; dialog.showModal(); }
  };
  const dismiss = () => {
    clearTimeout(timer);
    if (!review) write({ ...read(), dismissUntil: Date.now() + 7 * 24 * 60 * 60 * 1000 });
    if (dialog.open) dialog.close();
    if (previousFocus instanceof HTMLElement) previousFocus.focus();
  };
  opener.addEventListener('click', open);
  document.querySelectorAll('[data-welcome-announcement]').forEach((button) => {
    button.addEventListener('click', open);
    // Header access stays visible independently of popup dismissal or signup history.
  });
  root.querySelector('.welcome-review__open')?.addEventListener('click', open);
  root.querySelector('.welcome-gift__close').addEventListener('click', dismiss);
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); dismiss(); });
  const previewForm = root.querySelector('[data-preview-form]');
  if (previewForm) {
    const preview = (event) => {
      event.preventDefault();
      if (!previewForm.reportValidity()) return;
      root.querySelector('.welcome-gift__result').textContent = 'Preview success — your code: WELCOME15. The offer is inactive; no subscription was saved and no email was sent.';
      previewForm.reset();
    };
    previewForm.addEventListener('submit', preview);
    root.querySelector('[data-preview-submit]').addEventListener('click', preview);
  }
  if (root.querySelector('[data-signup-saved]')) {
    write({ signedUp: true });
    opener.hidden = true;
    open();
  } else if (review) {
    open();
  } else {
    opener.hidden = root.dataset.autoOpen !== 'true' || root.dataset.knownIneligible === 'true' || Boolean(read().signedUp);
    const schedule = () => {
      clearTimeout(timer);
      if (root.dataset.autoOpen === 'true' && !suppressed() && !dialog.open && matchMedia('(min-width: 750px)').matches && document.visibilityState === 'visible') timer = setTimeout(open, 12000);
    };
    ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach((name) => document.addEventListener(name, schedule, { passive: true }));
    document.addEventListener('visibilitychange', schedule);
    schedule();
  }
});

  } catch(e) { console.error(e); }
})();
})();
